import { Link } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';

const StyledLink = styled(Link)`
`;
const StyledCard = styled.div`
  background: ${props => props.backgroundColor ? props.backgroundColor : 'transparent'};
  border-radius: 3px;
  height: 100%;
  transition: all .25s ease;
`;

const CardLink = (props) => {
  return <StyledLink {...props}>
    <StyledCard backgroundColor={props.backgroundColor}>{props.children}</StyledCard>
  </StyledLink>;
}

export default CardLink;
